export default __webpack_public_path__ + "static/media/llh-logo.eba7993e.png";